import { useState } from "react";
import { useContent } from "@/context/ContentContext";

export default function ListingQuestionnaire() {
  const content = useContent();
  const [loaded, setLoaded] = useState(false);

  return (
    <div data-testid="listing-questionnaire-page">
      <div className="bg-[#2a0a12] text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <h1 className="font-serif text-4xl lg:text-5xl font-bold">{content.questionnaire_title}</h1>
          <p className="mt-3 text-slate-300 max-w-2xl">{content.questionnaire_subtitle}</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
          {!loaded && <div className="py-16 text-center text-slate-400">Loading form…</div>}
          <iframe
            src={content.questionnaire_form_url}
            title="BSD Listing Questionnaire"
            data-testid="questionnaire-iframe"
            onLoad={() => setLoaded(true)}
            width="100%"
            height="5115"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            className="w-full"
          >
            Loading…
          </iframe>
        </div>
      </div>
    </div>
  );
}
